import MetaTags from "./index";
import { useMemo } from "react";

const tags = {
  index: {
    vod: {
      title: "お問い合わせ | スカパー！動画ストア",
      keywords: "スカパー！動画ストア,動画配信,見放題,レンタル",
      description:
        "スカパー！動画ストアに関するお問い合わせはこちらから。スカパー！動画ストアではサッカー・プロレス・格闘技などの動画を配信中！",
      og: { type: "article" },
    },
  },
  confirm: {
    vod: {
      title: "お問い合わせ内容確認 | スカパー！動画ストア",
      keywords: "スカパー！動画ストア,動画配信,見放題,レンタル",
      description:
        "お問い合わせ内容確認。スカパー！動画ストアではサッカー・プロレス・格闘技などの動画を配信中！",
      og: { type: "article" },
    },
  },
  complete: {
    vod: {
      title: "お問い合わせ完了 | スカパー！動画ストア",
      keywords: "スカパー！動画ストア,動画配信,見放題,レンタル",
      description:
        "お問い合わせ完了。スカパー！動画ストアではサッカー・プロレス・格闘技などの動画を配信中！",
      og: { type: "article" },
    },
  },
};

export default function InquiryMetaTags({ action }) {
  const props = tags[action]["vod"];

  const noindex = useMemo(() => {
    if (action === "confirm" || action === "complete") return "noindex";
    return null;
  }, [action]);

  return <MetaTags {...props} robots={noindex} />;
}
